import httpService from '../Api/http.service';
import { getApiBaseUrl } from 'utils';

const createLocation = (payload) =>
  httpService({
    url: `/location`,
    method: 'post',
    data: payload,
  });

const createLocations = (payload) =>
  httpService({
    url: `/locations`,
    method: 'post',
    data: payload,
  });

const updateLocation = (data) =>
  httpService({
    url: `/location`,
    method: 'put',
    data,
  });

const deleteLocation = (payload) =>
  httpService({
    url: `/location`,
    method: 'delete',
    data: payload,
  });

const fetchLocationByPartnerId = (group_id, partner_id, params = '') => {
  let api = group_id
    ? `/locations?partner_id=${partner_id}&group_id=${group_id}${params}`
    : `/locations?partner_id=${partner_id}${params}`;

  return httpService({
    url: api,
    method: 'get',
  });
};

const updateLocationPlan = (location_id, plan_id, data) =>
  httpService({
    url: `/locations/${location_id}/plans/${plan_id}`,
    method: 'put',
    data,
  });

const setLocationPlans = (location_id, data) =>
  httpService({
    url: `/locations/${location_id}/plans`,
    method: 'post',
    data,
  });

const addLocationPlans = (location_id, data) =>
  httpService({
    url: `/location/${location_id}/plans`,
    method: 'post',
    data,
  });

const deleteLocationPlans = (location_id, data) =>
  httpService({
    url: `/location/${location_id}/plans`,
    method: 'delete',
    data,
  });

const getLocationByFacilityId = (facility_id) =>
  httpService({
    url: `${getApiBaseUrl()}/subscriberportal/locations?facid=${facility_id}`,
    method: 'get',
  });

const getSavingsSummary = (group_id, location_id) =>
  httpService({
    url: `${getApiBaseUrl()}/subscriberportal/savings-summary?group_id=${group_id}&location_id=${location_id}`,
    method: 'get',
  });

const getLocationPlanPackageFeeSchedule = (location_id, plan_package_id) =>
  httpService({
    url: `${getApiBaseUrl()}/loop/locations/${location_id}/plan-packages/${plan_package_id}/fee_schedule`,
    method: 'get',
    responseType: 'blob',
  });

const bulkUpdateLocations = (payload) =>
  httpService({
    url: `${getApiBaseUrl()}/appcore/locations/bulk`,
    method: 'patch',
    data: payload,
  });

const bulkImportRegionsLocations = (groupId, formData) =>
  httpService({
    url: `${getApiBaseUrl()}/appcore/groups/${groupId}/region-location-imports`,
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  });

const downloadBulkImportTemplate = (groupId) =>
  httpService({
    url: `${getApiBaseUrl()}/appcore/groups/${groupId}/region-location-imports/template`,
    method: 'get',
    responseType: 'blob',
  });

const locationService = {
  createLocation,
  createLocations,
  updateLocation,
  deleteLocation,
  fetchLocationByPartnerId,
  updateLocationPlan,
  setLocationPlans,
  addLocationPlans,
  deleteLocationPlans,
  getLocationByFacilityId,
  getSavingsSummary,
  getLocationPlanPackageFeeSchedule,
  bulkUpdateLocations,
  bulkImportRegionsLocations,
  downloadBulkImportTemplate,
};

export default locationService;
